import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
    TextField,
} from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSnackbar } from "notistack"
import { useEffect, useState } from "react"
import { RegistrarLogErro } from "../../services/clientefiel"
import { buscarestabelecimentos, parametrosId } from "../../services/integracao"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"

const useStyles = makeStyles({
    img: {
        width: "100px",
        height: "100px",
        margin: "auto",
        marginBottom: "1em",
        borderRadius: "15px",
        overflow: "hidden",
    },
    botaoCancelar: {
        backgroundColor: "#D32F2F",
        color: "white",
        "&:hover": {
            backgroundColor: "#E53935",
        },
    },
    botaoAlterar: {
        backgroundColor: "#388E3C",
        color: "white",
        "&:hover": {
            backgroundColor: "#4CAF50",
        },
    },
})

const DialogAlterarEstabelecimento = ({ open, handleToggleDialogAlterarEstabelecimento }) => {
    const autorizacao = localStorage.getItem("chaveSistema")
    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const classes = useStyles()

    const [estabelecimentoSelecionado, setEstabelecimentoSelecionado] = useState()
    const [estabelecimentosAssociados, setEstabelecimentosAssociados] = useState()

    const configs = useAppStore(s => s.configuracoes)
    const logo = configs?.user?.parametros?.estabelecimento?.urlLogo

    const handlebuscarEstabelecimentos = async () => {
        setLoading(true)
        try {
            const response = await buscarestabelecimentos(autorizacao)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                setLoading(false)
            } else {
                setEstabelecimentosAssociados(response)
            }
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
            alertStart("Erro ao buscar estabelecimentos", "error")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (!open) return
        handlebuscarEstabelecimentos()
    }, [open])

    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    return (
        <Dialog open={open} onClose={handleToggleDialogAlterarEstabelecimento} fullWidth>
            <DialogTitle>Alterar Establecimento</DialogTitle>
            <DialogContent>
                {logo && (
                    <div className={classes.img}>
                        <img width="100%" height="100%" src={logo} />
                    </div>
                )}
                <Autocomplete
                    options={estabelecimentosAssociados}
                    getOptionLabel={opcao => opcao.nome}
                    value={estabelecimentoSelecionado}
                    onChange={(_event, novoEstabelecimento) =>
                        setEstabelecimentoSelecionado(novoEstabelecimento)
                    }
                    renderOption={(props, opcao) => (
                        <li {...props} style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={props.urlLogo}
                                alt=""
                                style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: "50%",
                                    marginRight: 8,
                                }}
                            />
                            {props.nome}
                        </li>
                    )}
                    renderInput={params => (
                        <TextField {...params} label="Estabelecimento" variant="outlined" />
                    )}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    className={classes.botaoCancelar}
                    onClick={handleToggleDialogAlterarEstabelecimento}
                >
                    Cancelar
                </Button>
                <Button
                    className={classes.botaoAlterar}
                    onClick={async () => {
                        try {
                            const response = await parametrosId(
                                estabelecimentoSelecionado.id,
                                autorizacao
                            )

                            if (response.retornoErro) {
                                alertStart(response.mensagem, "error")
                                return
                            } else {
                                localStorage.setItem(
                                    "app",
                                    JSON.stringify(estabelecimentoSelecionado)
                                )

                                configs.user.parametros = response

                                atualizarConfiguracoes(configs)

                                localStorage.setItem("configs", JSON.stringify(configs))

                                window.location.reload()
                            }
                        } catch (error) {
                            console.log(error)
                            return
                        }
                    }}
                >
                    Alterar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogAlterarEstabelecimento
